<div class="container default-container popup-content show-desk" style="width: 40%;">
    <div class="popup-header row">
      <h2 class="col h-small">사용후기</h2>
      <a href="javascript:;" class="col-auto close-popup-btn" (click)="handleOnClickClosePopup();">
        <svg width="22" height="22" viewBox="0 0 22 22">
          <path d="M1 1L21 21" />
          <path d="M21 1L1 21" />
        </svg>
      </a>
    </div>

    <div class="popup-body">
      <div class="container default-container results searching-result">
        <div class="table-container" style="max-height: 50%;">
          <div class="review-pd">
            <ng-template #img1>
              <img src="./assets/img/noImage.jpg" alt="" class="userPhoto">
            </ng-template>
            <ng-template #img2>
              <img src="{{filePath}}" alt="" class="userPhoto">
            </ng-template>
            <ng-container *ngIf="filePath === ''; then img1; else img2">
            </ng-container>

            <input type="file" style="display: none" name="fileData" (change)="onFileSelected($event)" #fileUpload>
            <button type="button" id="saveImg" (click)="fileUpload.click()">추가</button>
          </div>

          <div class="review-pd review-starr" style="border:1px solid #ddd;">
            <div style="width: 10%; padding: 15px 0 13px 10px;">
              <span width="150" height="45">평점</span>
            </div>
            <div height="45" class="starrr bdl_ddd col-2" id="star">
              <span class="your-choice-was" style="display: none;">
                <span style="display:none;" class="choice"></span>
              </span>
              <a href="javascript:;" class="fa fa-star-o faPopup" id="faPopup1" (click)="setGrade(1)"></a>
              <a href="javascript:;" class="fa fa-star-o faPopup" id="faPopup2" (click)="setGrade(2)"></a>
              <a href="javascript:;" class="fa fa-star-o faPopup" id="faPopup3" (click)="setGrade(3)"></a>
              <a href="javascript:;" class="fa fa-star-o faPopup" id="faPopup4" (click)="setGrade(4)"></a>
              <a href="javascript:;" class="fa fa-star-o faPopup" id="faPopup5" (click)="setGrade(5)"></a>
            </div>
          </div>

          <div class="row info-row editor" style="padding: 3% 4% 3% 2%">
            <textarea name="contents" value="" id="contentsNew" ></textarea>
          </div>

          <div >
            <a id="writeBtn" class="ReviewConfirmBtn" (click)="handleSubmitReview();">후기작성</a>
          </div>

        </div>
      </div>
    </div>
</div>


<div class="container default-container popup-content show-mobile" style="width: 100%;">
  <div class="popup-header row">
    <h2 class="col h-small">사용후기</h2>
    <a href="javascript:;" class="col-auto close-popup-btn" (click)="handleOnClickClosePopup();">
      <svg width="22" height="22" viewBox="0 0 22 22">
        <path d="M1 1L21 21" />
        <path d="M21 1L1 21" />
      </svg>
    </a>
  </div>

  <div class="popup-body">
    <div class="container default-container results searching-result">
      <div class="table-container" style="max-height: 50%;">
        <div class="review-pd">
          <ng-template #img1>
            <img src="./assets/img/noImage.jpg" alt="" class="userPhoto">
          </ng-template>
          <ng-template #img2>
            <img src="{{filePath}}" alt="" class="userPhoto">
          </ng-template>
          <ng-container *ngIf="filePath === ''; then img1; else img2">
          </ng-container>

          <input type="file" style="display: none" name="fileData" (change)="onFileSelected($event)" #fileUpload>
          <button type="button" id="saveImg" (click)="fileUpload.click()">추가</button>
        </div>

        <div class="review-pd review-starr" style="border:1px solid #ddd;">
          <div style="width: 10%; padding: 15px 0 13px 10px;">
            <span width="150" height="45">평점</span>
          </div>
          <div height="45" class="starrr bdl_ddd col-2" id="star">
            <span class="your-choice-was" style="display: none;">
              <span style="display:none;" class="choice"></span>
            </span>
            <a href="javascript:;" class="fa fa-star-o faPopup" id="faPopup1" (click)="setGrade(1)"></a>
            <a href="javascript:;" class="fa fa-star-o faPopup" id="faPopup2" (click)="setGrade(2)"></a>
            <a href="javascript:;" class="fa fa-star-o faPopup" id="faPopup3" (click)="setGrade(3)"></a>
            <a href="javascript:;" class="fa fa-star-o faPopup" id="faPopup4" (click)="setGrade(4)"></a>
            <a href="javascript:;" class="fa fa-star-o faPopup" id="faPopup5" (click)="setGrade(5)"></a>
          </div>
        </div>

        <div class="row info-row editor">
          <textarea name="contents" value="" id="contentsNew" ></textarea>
        </div>

        <div class="btn-review-confirm">
          <a id="writeBtn" class="ReviewConfirmBtn" (click)="handleSubmitReview();">후기작성</a>
        </div>

      </div>
    </div>
  </div>
</div>

